import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'eiq-input-date-range',
  templateUrl: 'input-date-range.component.html',
  styleUrls: ['input-date-range.component.scss']
})
export class InputDateRangeComponent {
  @Input() dateRangeGrp: FormGroup;
  @Input() label: string;
  @Input() hint: string;
  @Input() min: Date;
  @Input() max: Date;
}
